import { Box, Paper, Skeleton, Typography } from '@mui/material';
import { ReactComponent as AdvisorProfileBottomGraphics } from 'app/assets/images/advisor_profile/main_bottom.svg';
import { ReactComponent as AdvisorProfileMainTopGraphics } from 'app/assets/images/advisor_profile/main_top.svg';
import { ReactComponent as AdvisorProfileOtherTopGraphics } from 'app/assets/images/advisor_profile/other_top.svg';
import styles from './AdvisorProfileCard.module.css';
import { Advisor } from 'types';
// import VSpace from '../VSpace';
import { useAdvisorProfileTheme } from './AdvisorProfileThemeProvider';

export type AdvisorProfileCardProps = {
  advisor?: Advisor;
  isMainCard?: boolean;
  heading?: string;
  loading?: boolean;
  children?: React.ReactNode;
  poweredBy?: React.ReactNode;
  onShowShortcut?: () => void;
  isDemo: boolean;
  isFreeUser: boolean;
  contentPadding?: string;
};

export default function AdvisorProfileCard({
  isMainCard = false,
  heading,
  loading = false,
  children,
  poweredBy,
  contentPadding = '10px 26px 16px 26px',
}: AdvisorProfileCardProps) {
  const { color2 } = useAdvisorProfileTheme();

  const cardSx = {
    position: 'relative',
    width: '295px',
    maxWidth: '85vw',
    // height: 'calc(100vh - 196px)',
    height: '600px',
    maxHeight: '88vh',
    overflow: 'hidden',
    borderRadius: '3px 90px 0px 90px',
    boxShadow: '5px 1px 8px 3px hsla(0,0%,42.7%,.5)',
  };
  if (loading) {
    return (
      <Skeleton variant="rectangular" width={300} height={600} sx={cardSx} />
    );
  }
  const screenUp: boolean = !(window.innerWidth > 400);
  // @media screen and (max-height: 800px) {
  //   .mainTopGraphics {
  //     top: calc((100vh - 800px) * 100vw / 100vh);
  //   }
  // }

  return (
    <Box
      style={{
        // borderRadius: '3px 90px 0px 90px',
        // boxShadow: '5px 4px 8px 3px hsla(0,0%,42.7%,.5)',
        // margin: '10px 0px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // height: 'inherit',
      }}
    >
      <Paper elevation={0} sx={cardSx}>
        {poweredBy && poweredBy}
        {isMainCard ? (
          // <div
          //   className="styles.mainTopGraphics"
          //   style={{
          //     width: '100%',
          //     height: '100%',
          //     backgroundImage: 'url("/images/main_top.svg"',
          //     backgroundSize: '100%',
          //   }}
          // ></div>
          <AdvisorProfileMainTopGraphics
            className={styles.mainTopGraphics}
            width={undefined}
            height={undefined}
            style={{ top: '-12px' }}
          />
        ) : (
          <AdvisorProfileOtherTopGraphics
            className={styles.otherTopGraphics}
            width={undefined}
            height={undefined}
          />
        )}

        <Box
          sx={{
            ...cardSx,
            position: isMainCard ? 'relative' : 'absolute',
            zIndex: 2,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {!isMainCard && heading && (
            <>
              <Box
                sx={{
                  paddingTop: '18px',
                  paddingX: '24px',
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    backgroundColor: color2,
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    marginRight: 10,
                    marginTop: 3,
                  }}
                />
                <Typography
                  variant="h5"
                  fontWeight={600}
                  sx={{ color: color2 }}
                >
                  {heading}
                </Typography>
              </Box>
              {/* <VSpace size={3} /> */}
            </>
          )}
          <Box
            sx={{
              padding: contentPadding,
              height: 'inherit',
              maxHeight: isMainCard ? undefined : '100%',
              overflowY: isMainCard ? 'hidden' : 'scroll',
              '&::-webkit-scrollbar': {
                width: '0px',
                marginRight: '-32px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: 'transparent',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                borderRadius: '3px',
              },
            }}
          >
            {children}
          </Box>
        </Box>
        <AdvisorProfileBottomGraphics
          className={styles.bottomGraphics}
          width={undefined}
          height={undefined}
        />
      </Paper>
    </Box>
  );
}
